export enum propertyType {
    local = 'local commercial',
    apartment = 'apartment',
    garage = 'garage'
}

export enum requestType {
    technical = 'technical',
    administrative = 'administrative'
}

export enum requestPurpose {
    private = 'private',
    common = 'common',
    sinisters = 'sinisters'
}

export enum propertyFromApi {
    local = 'Local commercial',
    apartment = 'Appartement',
    garage = 'Garage'
}

export enum propertyLabel {
    local = 'Local commercial',
    apartment = 'Appartement',
    garage = 'Parking'
}

export const paymentsMode = {
    221310000: 'CHQ',
    221310001: 'PRLAUTO',
    221310002: 'TIP',
    221310003: 'LCH',
    221310004: 'VIRAUTO',
    221310005: 'VIRM'
}

export const PRL_AUTO = 221310001
export const TIP = 221310002

// Libellés CRM des catégories juridiques de bail code civil (préavis de 3 mois)
export const categoriesJuridiquesCodeCivil = [
    'Bail Code Civil Habitation',
    'Bail Code Civil Tertiaire'
]

export const onlinePaymentMode = {
    all: 'ALL',
    partial: 'PARTIAL'
}

export enum contractsPhaseEnum  {
    exploitation = 'Exploitation'
}
